module.exports = __webpack_public_path__ + "testerstatic/media/psymetrics-new-logo.dd3dfbe9.svg";